import { CustomerSettingsOverviewSearchFilter } from 'src/modules/admin/customersettings/models/customerSettingsOverviewSearchFilter';
import { CustomerSettings } from 'src/modules/admin/customersettings/models/customerSettings';
import AxiosInstance from './axios/interceptor';
import { PagedResult } from '../models/pagedResult';

const controller = 'Customer';

export const getAllCustomer = (searchFilter: CustomerSettingsOverviewSearchFilter) => {
  return AxiosInstance.get<PagedResult<CustomerSettings>>(`${controller}`, { params: searchFilter });
};

export const getCustomerById = (id: number) => {
  return AxiosInstance.get<CustomerSettings>(`${controller}/${id}`);
};

export const updateCustomer = (customer: CustomerSettings) => {
  return AxiosInstance.put<CustomerSettings>(`${controller}`, customer);
};
